/**
* Logo Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'logo-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-marquee__splide' ).each( function( key, component ) {
        const $component = $( component );
        const $track = $component.find( '.splide__track' );
        const $list = $track.find( '.splide__list' );
        const $slides = $list.children();
        const screenWidth = window.innerWidth;
        let totalWidth = 0;

        // Calculate the total width of all slides
        $slides.each( function() {
          totalWidth += $( this ).outerWidth( true );
        } );

        // Clone slides until total width is at least 2x the screen width
        while ( totalWidth < screenWidth * 2 ) {
          $slides.clone().appendTo( $list );
          totalWidth = 0;
          $list.children().each( function() {
            totalWidth += $( this ).outerWidth( true );
          } );
        }

        new Splide( component, {
          type: 'loop',
          autoWidth: true,
          arrows: false,
          gap: '80px',
          pagination: false,
          autoScroll: {
            pauseOnHover: false,
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
